import '/app/brewery-packages/content/content-editor-plugin-emphasis/src/Emphasis.css-raw';
export default {
  "emphasis": "jobs-2ec46bc8-emphasis-Ihm-DG"
};